module.exports = "pegasus_template/assets/column-1-basic.png";